module.exports = __webpack_public_path__ + "./Oscar2_34b2f29934a3de0990aac456fc04aadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Oscar2.png
// module id = 575
// module chunks = 0